﻿import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import { Circle as CircleStyle, Icon, Fill, Stroke, RegularShape, Style, Text } from 'ol/style.js';
import Feature from 'ol/Feature.js';
import Circle from 'ol/geom/Circle.js';
import Collection from 'ol/Collection.js';
import { Utility } from '../Utility.js';
export { TrafficSignTool };

/**
 * Class RoadBuilderTool
 */
const TrafficSignTool = function () {

    // Define this
    var myTrafficSignTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Already initialize
    this._toolInitialize = false;

    // Hash that contains all reference 
    this._hashReference = {};

    // Array that contains all selected signs
    this._signsList = []

    // Buffer size for traffic sign subroad search in meters
    this._bufferSize = 500;

    // Buffer size ffor traffic sign subroad search in km
    this._bufferPoliceSizeKm = 0.5;

    // Array with all sub road near traffic sign
    this._arrayFeatureSubRoad = [];

    // Layer name for traffic sign closer
    this._layerSubRoadCloser = null;

    // Style sub road traffic sign closer
    this._styleSubRoadCloser = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.5)',
                width: 12
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.1)'
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(34, 139, 34, 0.5)',
                width: 4
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.5)'
            })
        })
    ];

    // List freguesia subroad
    this._listFreguesiaSubRoad = null;

    // List freguesia road
    this._listFreguesiaRoad = null;

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------

    // Layer name for traffice sign
    this.layerNameTrafficSign = "";

    // feature colection use in road builder tool
    this.collectionFeatureSet = new Collection();

    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Clean traffic sign information
     */
    this.Clean = function()
    {
        myTrafficSignTool._layerSubRoadCloser.getSource().clear();
        myTrafficSignTool._arrayFeatureSubRoad = [];
    }

    /**
     * Identify the nearest subroad of the traffice sign
     * @param {feature} featurePoint, feature point draw
     * @param {string} mode, mode of operation
     */
    this.IdentifySubRoadNearest = function(featurePoint, mode)
    {
        var coordinatePoint = null;

        switch(featurePoint.getGeometry().getType())
        {
            case "Point":
                coordinatePoint = featurePoint.getGeometry().getCoordinates();
                break;
            case "MultiPoint":
                coordinatePoint = featurePoint.getGeometry().getCoordinates()[0];
                break;
            default:
                return;
        };
        
        var bufferFeature = new Feature({ geometry: new Circle(coordinatePoint, myTrafficSignTool._bufferSize) });

        // Clear layer sub road police number closer
        myTrafficSignTool._layerSubRoadCloser.getSource().clear();

        // Calculate interception whit sub road
        var featureInWgs84 = featurePoint.clone();
        featureInWgs84.getGeometry().transform(myTrafficSignTool._mapSgs._settings.projection.code_, myTrafficSignTool._mapSgs._settings.projectionWgs84.code_);

        var coordinatePointWgs84 = null;
        switch(featureInWgs84.getGeometry().getType())
        {
            case "Point":
                coordinatePointWgs84 = featureInWgs84.getGeometry().getCoordinates();
                break;
            case "MultiPoint":
                coordinatePointWgs84 = featureInWgs84.getGeometry().getCoordinates()[0];
                break;
            default:
                return;
        };

        var pointCoord = turf.point(coordinatePointWgs84);
        var listIdInString = "";
        myTrafficSignTool._arrayFeatureSubRoad = [];
        var geojsonFormat = new GeoJSON();
        myTrafficSignTool.collectionFeatureSet.getArray().forEach(function(featureIn, index)
        {
            if(featureIn.getId().indexOf("V_ESTRADAS") >= 0)
            {
                var featureInWgs84 = featureIn.clone();
                featureInWgs84.getGeometry().transform(myTrafficSignTool._mapSgs._settings.projection.code_, myTrafficSignTool._mapSgs._settings.projectionWgs84.code_);
                var featureInGeoJson = geojsonFormat.writeFeatureObject(featureInWgs84);

                var distance = turf.pointToLineDistance(pointCoord, featureInGeoJson, {units: 'kilometers'});

                if( distance <= myTrafficSignTool._bufferPoliceSizeKm) {
                    myTrafficSignTool._arrayFeatureSubRoad.push({
                        distance: distance,
                        feature: featureIn
                    });
                    listIdInString += featureIn.getProperties().IDTROCO + ",";
                }
            }
        });

        // Remove last
        if(myTrafficSignTool._arrayFeatureSubRoad.length != 0) {
            // Order to get closet distance 
            myTrafficSignTool._arrayFeatureSubRoad = myTrafficSignTool._arrayFeatureSubRoad.sort((a, b) => (a.distance > b.distance) ? 1 : -1);

            // Build list of id sub road
            myTrafficSignTool._layerSubRoadCloser.getSource().addFeature(myTrafficSignTool._arrayFeatureSubRoad[0].feature);

            // Get freguesia subtoad
            myTrafficSignTool._GetFreguesiaSubRoad(myTrafficSignTool._arrayFeatureSubRoad[0].feature.getProperties().IDTROCO);
        }
        else {
            toastr["warning"]("Atenção, nenhum troço na proximidade");
        }
    }

    /**
     * Get list freguesia subroad form subroad id
     * @param {string} idSubRoad, subroad identifier
     */
    this._GetFreguesiaSubRoad = function(idSubRoad)
    {
        $.ajax({
            type: 'GET',
            url: '/rest/app/TrafficSignTool/GetFreguesiaFromSubRoad?idSubRoad=' + idSubRoad,
            contentType: "application/json",
            dataType: 'json',
            async: false,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da freguesia do sinal");
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            myTrafficSignTool._listFreguesiaSubRoad = data.result.list_freguesia_troco;
                            break;
                        default:
                            toastr["error"]("Erro na obtenção da freguesia do sinal");
                            break;
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da freguesia do sinal");
            }
        });
    }

    /**
     * Get list freguesia road form road id
     * @param {string} idRoad, road identifier
     */
    this._GetFreguesiaRoad = function(idRoad)
    {
        $.ajax({
            type: 'GET',
            url: '/rest/app/TrafficSignTool/GetFreguesiaFromRoad?idSubRoad=' + idRoad,
            contentType: "application/json",
            dataType: 'json',
            async: false,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da freguesia do arruamento");
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            myTrafficSignTool._listFreguesiaRoad = data.result.list_freguesia_troco;
                            break;
                        default:
                            toastr["error"]("Erro na obtenção da freguesia do sinal");
                            break;
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da freguesia do sinal");
            }
        });
    }

    /**
     * Build detail element
     */
    this.BuildDetailElement = function(objColumn, featureInfo)
    {
        let isRefColumn = false;
        let codUniverseTable = "";
        let codSelectItem = "";
        let descSelectItem = "";
        let columnName = objColumn.column_name
        let dataName = "";
        let columnValue = featureInfo.feature.getProperties()[columnName];
        let elementId = `id-traffic-sign-${columnName}`;
        let readOnly = (featureInfo.mode !== 'create' && featureInfo.mode !== "update")? true: false;

        switch (columnName) {
            case "FREGUESIA":
                var freguesiaName = "";
                var idSubRoadFreguesia = null;
                switch (featureInfo.mode) {
                    case 'create':
                        freguesiaName = myTrafficSignTool._listFreguesiaSubRoad[0].freguesia;
                        idSubRoadFreguesia = myTrafficSignTool._listFreguesiaSubRoad[0].id_freguesia_troco;
                        break;
                    default:
                        freguesiaName = columnValue;
                        idSubRoadFreguesia = featureInfo.feature.getProperties().IDFREGUESIATROCO;
                        if (idSubRoadFreguesia == null) {
                            myTrafficSignTool.IdentifySubRoadNearest(featureInfo.feature, "");
                            freguesiaName = myTrafficSignTool._listFreguesiaSubRoad[0].freguesia;
                            idSubRoadFreguesia = myTrafficSignTool._listFreguesiaSubRoad[0].id_freguesia_troco;
                        }
                }
                
                // Add field that contains ID for associated entity
                $('#id-offcanvas-body-layer-detail-field').append($(
                    '<div class="form-group offcanvas-body-layer-detail-row">'
                    + '<label for="id-traffic-sign-' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                    + '<input class="form-control ' + objColumn.column_type + '" type="text" value="' + freguesiaName + '" readOnly/>'
                    + '<input class="feature-field" type="hidden" name="IDFREGUESIATROCO" data-name="IDFREGUESIATROCO" value="' + idSubRoadFreguesia + '"/>'
                    + '</div > '
                ));
                return true;
                break;
            case "T_SITIPO":
                codUniverseTable = "traffic_sign_types";
                codSelectItem = "t_SITIPO";
                descSelectItem = "t_SITIPO";
                isRefColumn = true;
                break;
            case "T_SISUBTIPO":
                codUniverseTable = "traffic_sign_subtypes"
                codSelectItem = "t_SISUBTIPO";
                descSelectItem = "t_SISUBTIPO";
                isRefColumn = true;
                break;
            case "IDRRVSINAL":
                codUniverseTable = "traffic_sign_signs"
                isRefColumn = true;
                break;
            case "RRVESTADOCONSERVACAO":
                return true;
                break;
            case "IDRRVESTADOCONSERVACAO":
                codUniverseTable = "state_conservation";
                codSelectItem = "idrrvestadoconservacao";
                descSelectItem = "rrvestadoconservacao";
                dataName = "IDRRVESTADOCONSERVACAO";
                isRefColumn = true;
                break;
            case "RRVBORDADURAREGULAR":
                return true;
                break;
            case "IDRRVBORDADURAREGULAR":
                codUniverseTable = "bordadura_regular";
                codSelectItem = "idrrvbordaduraregular";
                descSelectItem = "rrvbordaduraregular";
                dataName = "IDRRVBORDADURAREGULAR";
                isRefColumn = true;
                break;
            case "RRVDIMENSAO":
                return true;
                break;
            case "DIAMETRO":
                codUniverseTable = "dimension";
                codSelectItem = "idrrvdimensao";
                descSelectItem = "rrvdimensao";
                dataName = "DIAMETRO";
                isRefColumn = true;
                break;
            case "RRVSIMULTANEO":
                return true;
                break;
            case "IDRRVSIMULTANEO":
                codUniverseTable = "list_simultaneo";
                codSelectItem = "idrrvsimultaneo";
                descSelectItem = "rrvsimultaneo";
                dataName = "IDRRVSIMULTANEO";
                isRefColumn = true;
                break;
            default:
                return false;
        };

        if (isRefColumn)
        {
            if (columnName === "IDRRVSINAL") {
                var elementIdSelected = elementId + "-selected";
                let signsElement = '<div class="form-group offcanvas-body-layer-detail-row">'
                    + '<span style="font-weight: bold;">Sinais</span>'
                    + '<div id="' + elementIdSelected + '"></div>'
                    + '<div id="' + elementId + '" class="traffic-sign-group ' + (readOnly?'ol-hidden':'') + '" ></div>'
                    + '<div>';

                $('#id-offcanvas-body-layer-detail-field').append(signsElement);

                var comboArray = myTrafficSignTool._hashReference[codUniverseTable];

                let typeValue = featureInfo.feature.getProperties()["T_SITIPO"];
                let subtypeValue = featureInfo.feature.getProperties()["T_SISUBTIPO"];

                comboArray = comboArray.filter(function (el) {
                    return el.t_SITIPO === typeValue && el.t_SISUBTIPO === subtypeValue;
                });

                var count = 0;
                comboArray.forEach(element => {
                    let signElementId = elementId + "_item_" + element.idrrvsinal;
                    let signElementDiv = signElementId + "_div";

                    let isChecked = (columnValue === element.idrrvsinal) ? 'checked' : '';

                    if(isChecked === 'checked')
                    {
                        $('#' + elementIdSelected).append($(`<div id="${signElementDiv}" style="margin: 10px 10px 10px 0px;">
                                            <label for="${signElementId}"></label>
                                            <input type="hidden" class="feature-field" name="${columnName}" data-name="${columnName}"/>
                                            <img src="/images/traffic-signs2/${element.idrrvsinal}.gif" alt="${element.idrrvsinal}" height="20" width="20" style="position: relative;bottom: 1px;"> 
                                            ${element.idrrvsinal}</div>`));
                        $('#' + elementIdSelected + " input").val( element.idrrvsinal);
                    }

                    var elementTrafficSign = $(`<div id="${signElementDiv}" class="col col-md-6" style="margin-bottom: 5px;padding: 0px;">
                                        <input type="radio" id="${signElementId}" name="traffic-sign-radio" value="${element.idrrvsinal}" ${isChecked}>
                                        <label for="${signElementId}" class="traffic-sign-radio-label"></label>
                                        <img src="/images/traffic-signs2/${element.idrrvsinal}.gif" alt="${element.idrrvsinal}" height="20" width="20"> 
                                        ${element.idrrvsinal}</div>`);

                    if(count%2 === 0) {
                        $('#' + elementId).append($('<div id="' + elementId + '-' + count +'" class="col col-md-12"></div>'));
                        $('#' + elementId + '-' + count).append(elementTrafficSign);
                    }
                    else {
                        $('#' + elementId + '-' + (count-1)).append(elementTrafficSign);
                    }

                    count++;
                });

                // event on radio choose change
                $('#' + elementId + " input[name='traffic-sign-radio']").off().on('change', function()
                {
                    $('#' + elementIdSelected).empty();
                    var value = $(this).parent().find('input').val();

                    var nodeElementChecked  = $(`<div id="${$(this).parent()[0].id}" style="margin: 10px 10px 10px 0px;">
                                            <label for="${$(this).parent().find('label').attr('for')}"></label>
                                            <input type="hidden" class="feature-field" name="IDRRVSINAL" data-name="IDRRVSINAL"/>
                                            <img src="/images/traffic-signs2/${value}.gif" alt="${value}" height="20" width="20" style="position: relative;bottom: 1px;"> 
                                            ${value}</div>`);

                    $('#' + elementIdSelected).append(nodeElementChecked);
                    $('#' + elementIdSelected + " input").val(value);
                });

                return true;
            };

            $('#id-offcanvas-body-layer-detail-field').append($(
                '<div class="form-group offcanvas-body-layer-detail-row">'
                + '<label for="id-traffic-sign-' + columnName + '">' + objColumn.pretty_name + '</label>'
                + '<select class="feature-field form-control ' + objColumn.column_type + '" id="' + elementId + '" name="' + dataName + '" data-name= "' + dataName + '" ' + (readOnly?'disabled':'') + '><option></option></select>'
                + '</div > '
            ));

            let newElement = $("#" + elementId);

            if (codUniverseTable === "traffic_sign_types")
            {
                newElement.on("changed.bs.select", function () {
                    var newTypeValue = this.value;
                    var subtypes = myTrafficSignTool._hashReference["traffic_sign_subtypes"];
                    subtypes = subtypes.filter(function (el) {
                        return el.t_SITIPO === newTypeValue;
                    });
                    myTrafficSignTool._utility.FillSelect("id-traffic-sign-T_SISUBTIPO", subtypes, "t_SISUBTIPO", "t_SISUBTIPO");
                    $("#id-traffic-sign-IDRRVSINAL").empty();
                });
            };

            if (codUniverseTable === "traffic_sign_subtypes")
            {
                newElement.on("changed.bs.select", function ()
                {
                    var elementId = "id-traffic-sign-IDRRVSINAL";
                    var elementIdSelected = elementId + "-selected";
                    var newSubtypeValue = this.value;
                    var signs = myTrafficSignTool._hashReference["traffic_sign_signs"];
                    signs = signs.filter(function (el) {
                        return el.t_SISUBTIPO === newSubtypeValue;
                    });

                    $("#" + elementId).empty();

                    var count = 0;
                    signs.forEach(element => {
                        let signElementId = elementId + "_item_" + element.idrrvsinal;
                        let signElementDiv = signElementId + "_div";

                        var elementTrafficSign = $(`<div id="${signElementDiv}" class="col col-md-6" style="margin-bottom: 5px;padding: 0px;">
                                        <input type="radio" id="${signElementId}" name="traffic-sign-radio" value="${element.idrrvsinal}">
                                        <label for="${signElementId}" class="traffic-sign-radio-label"></label>
                                        <img src="/images/traffic-signs2/${element.idrrvsinal}.gif" alt="${element.idrrvsinal}" height="20" width="20"> 
                                        ${element.idrrvsinal}</div>`);

                        if(count%2 === 0) {
                            $('#' + elementId).append($('<div id="' + elementId + '-' + count +'" class="col col-md-12"></div>'));
                            $('#' + elementId + '-' + count).append(elementTrafficSign);
                        }
                        else {
                            $('#' + elementId + '-' + (count-1)).append(elementTrafficSign);
                        }
                    });

                    // event on radio choose change
                    $('#' + elementId + " input[name='traffic-sign-radio']").off().on('change', function()
                    {
                        $('#' + elementIdSelected).empty();
                        var value = $(this).parent().find('input').val();

                        var nodeElementChecked  = $(`<div id="${$(this).parent()[0].id}" style="margin: 10px 10px 10px 0px;">
                                            <label for="${$(this).parent().find('label').attr('for')}"></label>
                                            <input type="hidden" class="feature-field" name="IDRRVSINAL" data-name="IDRRVSINAL"/>
                                            <img src="/images/traffic-signs2/${value}.gif" alt="${value}" height="20" width="20" style="position: relative;bottom: 1px;"> 
                                            ${value}</div>`);

                        $('#' + elementIdSelected).append(nodeElementChecked);
                        $('#' + elementIdSelected + " input").val(value);
                    });
                });
            };

            var comboArray = myTrafficSignTool._hashReference[codUniverseTable];

            if (codUniverseTable === "traffic_sign_subtypes") {
                let typeValue = featureInfo.feature.getProperties()["T_SITIPO"];
                comboArray = comboArray.filter(function (el) {
                    return el.t_SITIPO === typeValue;
                });
            };

            myTrafficSignTool._utility.FillSelect(elementId, comboArray, descSelectItem, codSelectItem);

            $('#' + elementId).selectpicker('val', columnValue);
            $('#' + elementId).selectpicker('refresh');

            return true;
        };
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
    * Get all references for traffic sign tool
    */
    this._GetAllReferences = function () {
        $.ajax({
            type: 'GET',
            url: '/rest/app/TrafficSignTool/GetAllReference',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myTrafficSignTool._hashReference['traffic_sign_types'] = data.result.list_traffic_sign_types;
                            myTrafficSignTool._hashReference['traffic_sign_subtypes'] = data.result.list_traffic_sign_subtypes;
                            myTrafficSignTool._hashReference['traffic_sign_signs'] = data.result.list_traffic_sign_signs;
                            myTrafficSignTool._hashReference['state_conservation'] = data.result.list_state_conservation;
                            myTrafficSignTool._hashReference['bordadura_regular'] = data.result.list_bordadura_regular;
                            myTrafficSignTool._hashReference['dimension'] = data.result.list_dimension;
                            myTrafficSignTool._hashReference['list_simultaneo'] = data.result.list_simultaneo;
                            
                            myTrafficSignTool._utility.FillSelect('id-signType',
                                data.result.list_traffic_sign_types, 't_SITIPO', 't_SITIPO', true);

                            break;
                        case 'ERROR':
                            toastr["error"]("Erro de carregamento da informação de referência");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });
    };

    /**
    * Get subtypes by selected type
    */
    this._GetSubtypesByType = function (type) {
        var subtypes = myTrafficSignTool._hashReference['traffic_sign_subtypes'];

        var filteredSubtypes = subtypes.filter(function (el) {
            return el.t_SITIPO === type;
        });

        myTrafficSignTool._utility.FillSelect('id-signSubtype',
            filteredSubtypes, 't_SISUBTIPO', 't_SISUBTIPO', true);
    };

    /**
    * Get signs by selected type and subtype
    */
    this._GetSignsByTypes = function (type, subtype) {
        var signs = myTrafficSignTool._hashReference['traffic_sign_signs'];

        var filteredSigns = signs.filter(function (el) {
            return el.t_SITIPO === type && el.t_SISUBTIPO === subtype;
        });

        var signArea = $('#id-signArea')[0];

        for (var i = 0; i < filteredSigns.length; i++) {
            var signDiv = document.createElement('div');
            signDiv.id = 'signDiv' + filteredSigns[i].idrrvsinal;
            signDiv.style = "margin: 2px;";
            signDiv.innerHTML =
                `<input type="checkbox" id="${filteredSigns[i].idrrvsinal}" name="traffic-sign-checkbox">
                <label for="${filteredSigns[i].idrrvsinal}" style="margin-bottom: -10px; padding-right: 15%; margin-left: 10%;"></label>
                <img src="/images/traffic-signs/${filteredSigns[i].idrrvsinal}.bmp" alt="${filteredSigns[i].idrrvsinal}" height="20" width="20"> 
                ${filteredSigns[i].idrrvsinal}`;

            signArea.appendChild(signDiv);
        };
    };

    /**
    * Search signs by signs ids
    */
    this._SearchSigns = function ()
    {
        myTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Build Filter
        var cqlFilter = "";
        var signType = $('#id-signType').val();
        var signSubtype = $('#id-signSubtype').val();
        var checkedSigns = myTrafficSignTool._signsList;

        if($('#id-freguesia').val() !== "") {
            cqlFilter = "FREGUESIA = '" + $('#id-freguesia').find("option:selected").text() + "'";
        }

        if (signType !== "") {
            var typeQuery = `T_SITIPO = '${signType}'`;
            if (cqlFilter === "") {
                cqlFilter = typeQuery;
            } else {
                cqlFilter = `${cqlFilter} AND ${typeQuery}`;
            }
        }

        if (signSubtype !== "") {
            var subtypeQuery = `T_SISUBTIPO = '${signSubtype}'`;

            if (cqlFilter === "") {
                cqlFilter = subtypeQuery;
            } else {
                cqlFilter = `${cqlFilter} AND ${subtypeQuery}`;
            }
        }

        if (checkedSigns.length > 0) {
            var signsQuery = "";
            var signsValues = "";

            checkedSigns.forEach(sign => {
                var fieldValue = `'${sign}'`;

                if (signsValues === "") {
                    signsValues = fieldValue;
                } else {
                    signsValues = `${signsValues}, ${fieldValue}`
                }
            });

            signsQuery = `IDRRVSINAL IN (${signsValues})`;

            if (cqlFilter === "") {
                cqlFilter = signsQuery;
            } else {
                cqlFilter = `${cqlFilter} AND ${signsQuery}`;
            }
        }

        // Get features
        var layerName = myTrafficSignTool._utility.GetPropertyInfoInConfigArray(myTrafficSignTool._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGN_TOOL", "LAYER_TRAFFIC_SIGN", "LAYER_NAME").value;
        var layerInfo = myTrafficSignTool._mapSgs.layerTree.FindLayerInfo(layerName);
        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var workspace = layerInfo.workspace;
        var cqlFilterLayer = layerInfo.cqlFilter;
        var cqlFilterResult = cqlFilter;
        if (cqlFilterLayer)
            cqlFilterResult += " And " + cqlFilterLayer;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilterResult,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    if (myTrafficSignTool._mapSgs.featureToHighLight.getLength() > 0)
                        myTrafficSignTool._mapSgs.featureToHighLight.clear();

                    myTrafficSignTool._mapSgs._arraySearchLayerFeatureActive = [];

                    var feature = null;
                    var layerName = myTrafficSignTool._utility.GetPropertyInfoInConfigArray(myTrafficSignTool._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGN_TOOL", "LAYER_TRAFFIC_SIGN", "LAYER_NAME").value;
                    var idLayer = myTrafficSignTool._mapSgs.layerTree.FindLayerInfo(layerName).id;
                    var workspace = myTrafficSignTool._mapSgs.layerTree.FindLayerInfo(layerName).workspace;

                    var columnDefArray = [];
                    var columDefArrayExpand = [];
                    var columDefArrayExpandSize = [];
                    var columnValueArray = [];
                    var idPrimaryKey = null;
                    var featureHash = {};

                    for (let i = 0; i < data.features.length; i++) {
                        feature = (new GeoJSON()).readFeatures(data)[i];
                        idPrimaryKey = feature.getId().split(".")[1];
                        featureHash[idPrimaryKey] = feature;

                        // Save feature Search
                        myTrafficSignTool._mapSgs._arraySearchLayerFeatureActive.push(feature);

                        // Build column info
                        var objRow = {};
                        for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                            var columnName = Object.keys(feature.getProperties())[j];

                            if (columnName === "geometry")
                                continue;

                            var value = feature.getProperties()[columnName];
                            var columnProperties = myTrafficSignTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(obj => {
                                return obj.column_name === columnName
                            })[0];

                            // If value is a system date, format string
                            //if (new Date(value) != 'Invalid Date' && isNaN(value))
                            if (columnProperties) {
                                if (columnProperties.column_type == 'xsd:date-time')
                                    value = myTrafficSignTool._utility.TransformDateServerInDateTime(value);

                                objRow[columnName] = value;
                                if (columDefArrayExpandSize[columnName]) {
                                    if (value) {
                                        var valueSize = value.toString().length;
                                        columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                                    }
                                }
                                else {
                                    if (value)
                                        columDefArrayExpandSize[columnName] = value.toString().length;
                                    else
                                        columDefArrayExpandSize[columnName] = 30; // If fist empty
                                }
                                if (i === 0) {
                                    var columnSearchResult = myTrafficSignTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result;
                                    var visible = myTrafficSignTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).visible;
                                    var columnPrettyName = myTrafficSignTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).pretty_name;
                                    var searchResultOrder = myTrafficSignTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result_order;

                                    if (columnSearchResult) {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px',
                                            'search_order': searchResultOrder
                                        });
                                    } else {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false,
                                            'search_order': 0
                                        });
                                    }
                                    if (visible) {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px'
                                        });
                                    }
                                    else {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false
                                        });
                                    }
                                }
                            }
                        }
                        // Order columns by search order
                        columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                        // Add primary key value
                        objRow["id_primary_key"] = idPrimaryKey;

                        // Add array row
                        columnValueArray.push(objRow);

                        // Put in feature highlight
                        myTrafficSignTool._mapSgs.featureToHighLight.push(feature);
                        var styleElement = myTrafficSignTool._mapSgs._defaultHighlighStyles;
                        myTrafficSignTool._mapSgs.featureToHighLight.getArray()[myTrafficSignTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                    }

                    // Add primary key to array
                    columnDefArray.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    columDefArrayExpand.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    // Add size to column in array expand
                    for (let i = 0; i < columDefArrayExpand.length; i++) {
                        var objDef = columDefArrayExpand[i];
                        if (objDef.width) {
                            if (columDefArrayExpandSize[objDef.data] > 50)
                                objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                            else
                                objDef.width = "50px";
                            columDefArrayExpand[i] = objDef;
                        }
                    };

                    // Show canvas search result
                    myTrafficSignTool._utility.ShowOpenCanvas3('offcanvas-search-result', true);

                    // Make datatable list
                    myTrafficSignTool._mapSgs.InitSearchResultTable(workspace, layerName, idLayer, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, myTrafficSignTool._mapSgs.DetailElement);

                    // Go to Feature
                    myTrafficSignTool._mapSgs.map.getView().fit(myTrafficSignTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myTrafficSignTool._mapSgs.map.getSize() });

                    // Remove hide in offcanvas search result information
                    $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                    $('#id-offcanvas-search-result-body').removeClass('ol-hidden');
                }
                else {
                    toastr["warning"]("Não foi encontrado nenhum elemento");
                }
            }

            // Stop wait
            myTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', false);
        });
    };

    // -- end private method --------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    $('#id-signType').on('changed.bs.select', function () {
        $("#id-signArea").empty();
        myTrafficSignTool._GetSubtypesByType(this.value);
    });

    $('#id-signSubtype').on('changed.bs.select', function () {
        $("#id-signArea").empty();
        var type = $('#id-signType').val();
        myTrafficSignTool._GetSignsByTypes(type, this.value);
    });

    $('#id-buttonsearchTrafficSign').on('click', function () {
        myTrafficSignTool._signsList = [];

        var checkedSigns = document.querySelectorAll('input[name=traffic-sign-checkbox]:checked');

        checkedSigns.forEach(element => {
            myTrafficSignTool._signsList.push(element.id);
        });

        myTrafficSignTool._SearchSigns();
    });

    // -- end event -------------------------------------------------------------------------------
};

/**
 * Init traffic sign tool
 * @param {object} mapSgs, map object
 */
TrafficSignTool.prototype.Init = function (mapSgs) {
    if (!this._toolInitialize) {
        this._toolInitialize = true;

        // Set map info
        this._mapSgs = mapSgs;

        // Get layer name for traffice sign
        this.layerNameTrafficSign = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGN_TOOL", "LAYER_TRAFFIC_SIGN", "LAYER_NAME").value;

        // Layer sub road traffic sign closer
        this._layerSubRoadCloser = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleSubRoadCloser
        });
        this._mapSgs.map.addLayer(this._layerSubRoadCloser);

        // -- Get all references --
        this._GetAllReferences();
    }
};